import { advancedForm } from './advancedForm';
import { baseForm } from './baseForm';

export const attributesForm = {
  advanced: advancedForm,
  base: baseForm,
};
